<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <alert></alert> <!-- rederizando componente alert -->
                <div class="box box-solid">
                    <div class="box-header with-border">
                        <h3 class="box-title"><b>Empresas</b></h3>
                        <router-link tag="button" class="btn btn-primary pull-right" to="/empresas/novo"><i class="fa fa-plus"></i> Nova</router-link>
                    </div>

                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-12">
                                <input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome da empresa" name="filtro_pesquisa" type="text" v-model="filtro" @keyup.enter="getEmpresas">
                            </div>
                        </div>
                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th>Fantasia</th>
                                            <th>CNPJ</th>
                                            <th>Telefone</th>
                                            <th>Email</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="item in apiData.data">
                                            <td>{{ item.fantasia }}</td>
                                            <td>{{ item.cpf_cnpj }}</td>
                                            <td>{{ item.tel1 }} {{ item.tel2 }} {{ item.tel3 }}</td>
                                            <td>{{ item.email }}</td>
                                            <td>
                                                <router-link tag="a"  :to="'/empresas/atualizacao/'+ item.id" title="Editar"><i class="fa fa-fw fa-edit"></i></router-link>
                                                <a title='Excluir' href="javascript:void(0)" @click="deleteEmpresa(item.id, item.name)"><i class="fa fa-fw fa-times"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class='col-sm-5'>
                                        Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
                                    </div>
                                    <div class='col-sm-7' style="text-align:right">
                                        <laravue-pagination :data="apiData" v-on:pagination-change-page="getEmpresas">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> <!-- /.box-body -->
                </div> <!-- /.box -->
            </div> <!-- /.col-md-12 -->
        </div> <!-- /.row -->
    </section>
</template>
<script>
    import axios from 'axios' // Cliente para requisição http
    import Alert from '../Alert' // Importando componente alert 

    export default {
        data: () => ({
            filtro: '',
            apiData: {},
        }),
        mounted () {
            this.getEmpresas()
        },

        methods: {
            selecionaUsuario(user) {
                this.usuarioSelecionado = user;
                this.showResetPassword = true;
            },
            updateSenha(password) {
                axios.post(`${this.$store.state.serverURI}/api/usuario/updatePassword/` + this.usuarioSelecionado.id, {password}, this.$store.getters.getHeaderAuth).then(response => {

                  this.$store.commit('SHOW_ALERT_SUCCESS');
                  this.$router.push('/empresas');

              }).catch((error) => {
                  this.$store.commit('SHOW_ALERT_ERROR');
                  console.log(error)
              });
          },
          getEmpresas(page) {
            if (typeof page === 'undefined') {
                page = 1;
            }
            this.$store.commit('TOGGLE_LOADING');
            axios.get(`${this.$store.state.serverURI}/api/empresa/getAllPaginate` + ((this.filtro) ? '/' + this.filtro : '') + '/?page=' + page, this.$store.getters.getHeaderAuth)
            .then(response => {
                this.apiData = response.data;
                this.$store.commit('TOGGLE_LOADING');
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
    },
    watch: {
        page: function (val) {
            this.getEmpresas();
        }
    },

    components: {
        Alert,
    }

}
</script>
<style>
    .box.box-solid>.box-header .btn.btn-default {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }

    .box.box-solid>.box-header .btn.btn-default:hover {
       color: #333;
       background-color: #d4d4d4;
       border-color: #8c8c8c;
   }


</style>


// WEBPACK FOOTER //
// List.vue?293bcb30